import type { TableColumn } from "@shared/types/query";
import { create } from "zustand";

type Mode = "create" | "edit";
type PrimaryID = string | number;

type FormState = {
  openFormSheet: boolean;
  mode?: Mode;
  id?: PrimaryID;
  formFields: TableColumn[];
  formValues: Record<string, unknown>;
};

type FormActions = {
  setOpenFormSheet: (
    openFormSheet: boolean,
    formValues?: Record<string, unknown>,
    mode?: Mode,
    id?: PrimaryID
  ) => void;

  reset: () => void;
  setFormFields: (formFields: TableColumn[]) => void;
};

type FormStore = FormState & FormActions;

const defaultState: FormState = {
  mode: "create",
  openFormSheet: false,
  formFields: [],
  formValues: {},
};

export const useFormStore = create<FormStore>((set) => ({
  ...defaultState,
  setOpenFormSheet: (
    openFormSheet: boolean,
    formValues: Record<string, unknown> = {},
    mode = "create",
    id?: PrimaryID
  ) => {
    set({ openFormSheet, mode, id, formValues });
  },

  setFormFields: (formFields: TableColumn[]) => {
    set({ formFields });
  },
  reset: () => set(defaultState),
}));
